export enum ShareItemTypes {
  FIELD = 'Field',
  FEED = 'Feed',
}

export enum SharingRoles {
  ADMIN = 'Admin',
  BASIC = 'Basic',
}

export type ShareItem = {
  id: string;
  shareType: ShareItemTypes;
};

export type ShareInvitation = {
  currentInvitationId?: string;
  inviteEmail: string;
  shareType: ShareTypes;
  sharedItems: ShareItem[];
  metadata?: {
    role: SharingRoles;
  };
};

export type ShareEditInvitation = {
  id: string;
  status: SharingStatus;
  metadata: {
    role: SharingRoles;
  };
};

export type SharingMessage = {
  id: string;
  sharedByCompanyId: string;
  sharedByCompanyName: string;
  sharedToCompanyId: string;
  sharedToCompanyName: string;
  shareType: ShareTypes;
  inviteId: string;
  inviteToken: string;
  sender: string; // sender email
  inviteEmail: string;
  inviteDate: string;
  status: string;
  sharedItems: [];
  metadata?: {
    role: SharingRoles;
  };
};

export enum SharingStatus {
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  OVERDUE = 'Overdue',
}

export enum SharingType {
  RECEIVED = 'Received',
  SENT = 'Sent',
}

export enum ShareTypes {
  FIELDS_SET = 'FieldsSet',
  FEED_SET = 'FeedSet',
  CARTS_SET = 'CartsSet',
}

export type SharingPartner = {
  id: string;
  name: string | null;
  mail: string;
  status: SharingStatus;
  type: SharingType | null;
  sharedItems: ShareItem[];
  date: string;
  inviteToken: string;
  metadata?: {
    role: SharingRoles;
  };
};
